module.exports = __webpack_public_path__ + "static/media/karie-logo.049acf1b.png";